import type Lenis from 'lenis';

let lenis: Lenis | null = null;

export const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;

export function setLenis(instance: Lenis | null) {
  lenis = instance;
}

/** Scroll to an element id, honouring Lenis when it is driving the page. */
export function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -12, duration: 1.1 });
  else el.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
}

/**
 * Reduced motion, low memory, or an explicit data-saving preference means no
 * WebGL layer at all — the CSS composition stands in and nothing is lost but
 * decoration. `prefers-reduced-transparency` is deliberately NOT consulted: it
 * describes translucent UI chrome, not opaque decorative canvases, and reads
 * `reduce` in enough headless and enterprise contexts to be a bad proxy.
 */
export function shouldRenderField() {
  if (typeof window === 'undefined') return false;
  if (prefersReducedMotion()) return false;
  const nav = navigator as Navigator & {
    deviceMemory?: number;
    connection?: { saveData?: boolean };
  };
  if (typeof nav.deviceMemory === 'number' && nav.deviceMemory <= 3) return false;
  if (nav.connection?.saveData) return false;
  return true;
}
